import {Attribute, AttributeStat} from "@/characters/model/Character.ts";

export const getAttribute = (attributes: Attribute[], stat: AttributeStat) =>
    attributes.find(attribute => attribute.stat == stat)!

export const calculateModifier = (value: number): number => {
    return Math.round((value - 10.1) / 2);
}

export const formattedModifier = (modifier: number): string => {
    return `(${modifier > 0 ? "+" :''}${modifier})`;
}
